import React, {useState} from "react";
import "../../assets/styles/components/checkBox.scss";
import {useDispatch} from "react-redux";
import {CheckBoxValue} from "../../store/actions/index";

export default function CheckBox(props) {
    const {changeValue} = props;
    const [switchCheckBox, setSwitchCheckBox] = useState(false);
    const dispatch = useDispatch();
    return (
        <div className="warp-check-box">
            <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckDefault"
                checked={switchCheckBox}
                onChange={(ev) => {
                    setSwitchCheckBox(!switchCheckBox);
                    changeValue(!switchCheckBox,ev);
                    dispatch(CheckBoxValue(switchCheckBox, props.label));
                }}
            />
            <label className="form-check-label" htmlFor="flexCheckDefault">
                {props.label}
            </label>
        </div>
    );
}
